var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4001 3.33998L13.6601 0.599983C12.9198 -0.0953634 11.7759 -0.125466 11.0001 0.529983L2.00006 9.52998C1.67682 9.85595 1.47556 10.2832 1.43006 10.74L1.00006 14.91C0.972783 15.2065 1.07909 15.4998 1.29006 15.71C1.47878 15.8972 1.73425 16.0015 2.00006 16H2.09006L6.26006 15.62C6.71685 15.5745 7.14409 15.3732 7.47006 15.05L16.4701 6.04998C17.1973 5.28164 17.166 4.06975 16.4001 3.33998Z",
    fill: "#2E2B63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08005 13.6199L3.08005 13.8999L3.35005 10.8999L9.00005 5.31995L11.7 8.01995L6.08005 13.6199Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 6.68L10.3201 4L12.2701 2L15.0001 4.73L13.0001 6.68Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCopy);
export default __webpack_public_path__ + "static/media/edit_copy.ead8c314148e52c788ffef6fe111de58.svg";
export { ForwardRef as ReactComponent };